<template>
  <div
    ref="refresh"
    class="vr360-refresh"
    :style="{ opacity: refreshOpacity, transform: refreshTranslate }"
    :class="{'no-transition': needRefresh}"
  >
    <span class="vr360-refresh__circle">
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          stroke-dasharray="30"
          :stroke-dashoffset="refreshDashOffset"
          cx="5"
          cy="5"
          r="4.5"
          stroke-width="1px"
          stroke="currentColor"
        ></circle>
      </svg>
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      refreshOpacity: ".5",
      refreshTranslate: "translate3d(0, -100%, 0)",
      refreshDashOffset: 30,
      needRefresh: false
    };
  },
  mounted() {
    // setTimeout(() => {
      this.parent = this.$parent.$refs.list;
      this.parent.addEventListener("touchstart", this.touchStartHandler);
      this.parent.addEventListener("touchmove", this.touchMoveHandler);
      this.parent.addEventListener("touchend", this.touchEndHandler);
    // }, 100);

    this.touchStart = false;
    this.startPointY = 0;
    this.refreshDistance = 150;
    this.percent = 0;
  },
  beforeDestroy() {
    this.parent.removeEventListener("touchstart", this.touchStartHandler);
    this.parent.removeEventListener("touchmove", this.touchMoveHandler);
    this.parent.removeEventListener("touchend", this.touchEndHandler);
  },
  methods: {
    touchStartHandler(e) {
      if (this.getScrollBlock.scrollTop === 0) {
        this.touchStart = true;
        this.startPointY = e.changedTouches[0].clientY;
        this.needRefresh = true;
      }
    },
    touchMoveHandler(e) {
      if (!this.touchStart) return;

      const diff = Math.max(e.changedTouches[0].clientY - this.startPointY, 0);
      this.percent = Math.min(diff / this.refreshDistance, 1);

      this.refreshAnimation(this.percent);
    },
    touchEndHandler(e) {
      if (!this.touchStart) return;

      if (this.percent >= 1) {
        this.$emit("refresh-list");
      }

      this.percent = 0;
      this.refreshAnimation(this.percent);
      this.needRefresh = false;
      this.touchStart = false;
    },
    refreshAnimation(percent) {
      this.refreshOpacity = percent + 0.5;
      this.refreshTranslate = `translate3d(0, ${(percent - 1) * 100}%, 0)`;
      this.refreshDashOffset = 30 * (1 - percent);
    }
  },
  computed: {
    ...mapGetters({
      getScrollBlock: "getScrollBlock"
    })
  }
};
</script>

<style lang="scss">
</style>
